/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

angular.module('taric.model.links',['common.helper', 'ngResource']).factory('TariffLinks', function ($resource, CONSTANTS) {
    return $resource(CONSTANTS.host + CONSTANTS.ws_context + '/link/links', {}, {
        queryLinksExternal: {
            method: 'GET',
            isArray: false
        },
        queryLinks: {
            method: 'GET',
            isArray: false,
            url: CONSTANTS.host + CONSTANTS.ws_context + '/link/links/:type'
        }
    });
}).service('TaricLinksSearchModel', function(TariffLinks, $q, CommonHelper, CONSTANTS){
    var model = this;
    model.searchTariffLinks = function(page){
        let deferred = $q.defer();
        let options = {
        	simulationdate: CommonHelper.getRestDateString(new Date())
        };
        
        if (page) {
        	options.offset = CommonHelper.getOffset(page);
        	options.count = CONSTANTS.rowsPerPage;
        }
        
        let result = TariffLinks.queryLinksExternal(options, function () {
            let searchLinksResult = {};
            searchLinksResult.totalItems = result.count;
            searchLinksResult.tariffLinks = result.items;
            searchLinksResult.currentLinksPage= page;
            deferred.resolve(searchLinksResult);
        }, function(error){
            deferred.reject(error);
        });
        return deferred.promise;
    };
    model.searchTariffLinksType = function(type, simulationDate){
        let deferred = $q.defer();
        let result;
        if (simulationDate !== null && simulationDate !== undefined) {
            result = TariffLinks.queryLinks({
                type: type,
                simulationdate: CommonHelper.getRestDateString(simulationDate)
            }, function () {
                let searchLinksResult = {};
                searchLinksResult.count = result.count;
                searchLinksResult.items = result.items;
                deferred.resolve(searchLinksResult);
            }, function(error){
                deferred.reject(error);
            });
        } else {
            result = TariffLinks.queryLinks({
                type: type
            }, function () {
                let searchLinksResult = {};
                searchLinksResult.count = result.count;
                searchLinksResult.items = result.items;
                deferred.resolve(searchLinksResult);
            }, function(error){
                deferred.reject(error);
            });
        }
        return deferred.promise;
    };

});



// WEBPACK FOOTER //
// ./app/taric/moreinfo/links/links-model.js